import React, { useEffect, lazy, createElement } from 'react';
import { motion } from 'framer-motion';
import { User, Mail, Phone, PhoneCallIcon, MapPin, List } from 'lucide-react';
import { SEOHead } from '../components/SEOHead';
export function ContactUs() {
  useEffect(() => {
    const script = document.createElement('script');
    script.type = 'application/ld+json';
    script.id = 'ld-breadcrumb-contact';
    script.textContent = JSON.stringify({
      '@context': 'https://schema.org',
      '@type': 'BreadcrumbList',
      itemListElement: [{
        '@type': 'ListItem',
        position: 1,
        name: 'Home',
        item: window.location.origin + '/'
      }, {
        '@type': 'ListItem',
        position: 2,
        name: 'Contact Us',
        item: window.location.origin + '/contact'
      }]
    });
    document.head.appendChild(script);
    return () => {
      document.getElementById('ld-breadcrumb-contact')?.remove();
    };
  }, []);
  return <main className="min-h-screen bg-light pb-24" data-id="element-911">
      <SEOHead title="Contact Us | Smith & Jengs Cleaning Services" description="Get in touch with Smith & Jengs for a free cleaning quote. Call 01869 601439 or 07432 285564, or book online. Serving Bicester and Oxfordshire." data-id="element-912" />
      {/* Dark Page Hero */}
      <section className="bg-primary pt-36 md:pt-44 pb-16 md:pb-24 relative overflow-hidden" data-id="element-913">
        <div className="absolute inset-0 opacity-10 pointer-events-none" style={{
        backgroundImage: 'radial-gradient(rgba(255,255,255,0.15) 1px, transparent 1px)',
        backgroundSize: '24px 24px'
      }} data-id="element-914"></div>
        <div className="container mx-auto px-6 md:px-12 relative z-10 text-center" data-id="element-915">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.6
        }} data-id="element-916">
            <h1 className="text-5xl md:text-7xl lg:text-8xl font-heading font-bold text-white uppercase leading-none tracking-tight" data-id="element-917">
              Contact Us
            </h1>
          </motion.div>
        </div>
      </section>

      {/* Main Content */}
      <section className="container mx-auto px-6 md:px-12 py-16 md:py-24" data-id="element-918">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12" data-id="element-919">
          {/* Request Callback Form */}
          <motion.div initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6
        }} className="bg-white rounded-2xl shadow-xl p-8 md:p-12 border border-gray-100" data-id="element-920">
            <h2 className="text-3xl font-heading font-bold text-primary mb-8 text-center" data-id="element-921">
              Request Callback
            </h2>
            <form className="space-y-6" onSubmit={e => e.preventDefault()} data-id="element-922">
              <div className="grid grid-cols-1 sm:grid-cols-2 gap-6" data-id="element-923">
                <div className="relative" data-id="element-924">
                  <input type="text" placeholder="First Name" aria-label="First Name" className="w-full px-5 py-4 pr-12 rounded-xl border border-gray-200 bg-gray-50 focus:bg-white focus:ring-2 focus:ring-accent focus:border-accent outline-none transition-all text-primary" data-id="element-925" />
                  <User className="absolute right-4 top-1/2 -translate-y-1/2 text-gray-400" size={20} data-id="element-926" />
                </div>
                <div className="relative" data-id="element-927">
                  <input type="text" placeholder="Last Name" aria-label="Last Name" className="w-full px-5 py-4 pr-12 rounded-xl border border-gray-200 bg-gray-50 focus:bg-white focus:ring-2 focus:ring-accent focus:border-accent outline-none transition-all text-primary" data-id="element-928" />
                  <User className="absolute right-4 top-1/2 -translate-y-1/2 text-gray-400" size={20} data-id="element-929" />
                </div>
              </div>

              <div className="relative" data-id="element-930">
                <input type="email" placeholder="Email address" aria-label="Email address" className="w-full px-5 py-4 pr-12 rounded-xl border border-gray-200 bg-gray-50 focus:bg-white focus:ring-2 focus:ring-accent focus:border-accent outline-none transition-all text-primary" data-id="element-931" />
                <Mail className="absolute right-4 top-1/2 -translate-y-1/2 text-gray-400" size={20} data-id="element-932" />
              </div>

              <div className="relative" data-id="element-933">
                <input type="tel" placeholder="Your phone number" aria-label="Phone number" className="w-full px-5 py-4 pr-12 rounded-xl border border-gray-200 bg-gray-50 focus:bg-white focus:ring-2 focus:ring-accent focus:border-accent outline-none transition-all text-primary" data-id="element-934" />
                <Phone className="absolute right-4 top-1/2 -translate-y-1/2 text-gray-400" size={20} data-id="element-935" />
              </div>

              <div className="relative" data-id="element-936">
                <input type="text" placeholder="Postal Code" aria-label="Postal Code" className="w-full px-5 py-4 pr-12 rounded-xl border border-gray-200 bg-gray-50 focus:bg-white focus:ring-2 focus:ring-accent focus:border-accent outline-none transition-all text-primary" data-id="element-937" />
                <MapPin className="absolute right-4 top-1/2 -translate-y-1/2 text-gray-400" size={20} data-id="element-938" />
              </div>

              <div className="relative" data-id="element-939">
                <input type="text" placeholder="Subject" aria-label="Subject" className="w-full px-5 py-4 pr-12 rounded-xl border border-gray-200 bg-gray-50 focus:bg-white focus:ring-2 focus:ring-accent focus:border-accent outline-none transition-all text-primary" data-id="element-940" />
                <List className="absolute right-4 top-1/2 -translate-y-1/2 text-gray-400" size={20} data-id="element-941" />
              </div>

              <div data-id="element-942">
                <label className="text-gray-600 block mb-2" htmlFor="additional-info" data-id="element-943">
                  Additional information
                </label>
                <textarea id="additional-info" aria-label="Additional information" className="w-full px-5 py-4 rounded-xl border border-gray-200 bg-gray-50 focus:bg-white focus:ring-2 focus:ring-accent focus:border-accent outline-none transition-all min-h-[150px] text-primary resize-y" data-id="element-944"></textarea>
              </div>

              <div className="pt-6 border-t border-gray-100 flex justify-center" data-id="element-945">
                <button type="submit" className="bg-white border border-gray-300 hover:bg-gray-50 text-gray-700 px-12 py-3 rounded text-lg transition-all shadow-sm" data-id="element-946">
                  Send
                </button>
              </div>
            </form>
          </motion.div>

          {/* Contact Info Card */}
          <motion.div initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6,
          delay: 0.2
        }} className="space-y-8" data-id="element-947">
            <div className="bg-white rounded-2xl shadow-xl p-8 md:p-12 border border-gray-100" data-id="element-948">
              <h2 className="text-3xl font-heading font-bold text-primary mb-6 text-center" data-id="element-949">
                Contact Us
              </h2>
              <p className="text-gray-500 text-center mb-10 leading-relaxed" data-id="element-950">
                We're happy to answer any questions you have and provide you
                with more information. Just send us a message and we'll get back
                to you as soon as we can!
              </p>

              <div className="space-y-6" data-id="element-951">
                <div data-id="element-952">
                  <h3 className="text-xl font-heading font-bold text-primary mb-2" data-id="element-953">
                    Smiths & Jengs Cleaning Services
                  </h3>
                  <p className="text-gray-600" data-id="element-954">
                    Bicester
                    <br data-id="element-955" />
                    United Kingdom
                  </p>
                </div>

                <div className="space-y-4 pt-6 border-t border-gray-100" data-id="element-956">
                  <a href="tel:+441869601439" className="flex items-center gap-3 text-gray-600 hover:text-accent transition-colors" data-id="element-957">
                    <PhoneCallIcon size={20} className="text-gray-400" data-id="element-958" />
                    01869 601439
                  </a>
                  <a href="tel:+447432285564" className="flex items-center gap-3 text-gray-600 hover:text-accent transition-colors" data-id="element-959">
                    <Phone size={20} className="text-gray-400" data-id="element-960" />
                    07432 285564
                  </a>
                  <a href="mailto:smithsandjengs@yahoo.com" className="flex items-center gap-3 text-gray-600 hover:text-accent transition-colors" data-id="element-961">
                    <Mail size={20} className="text-gray-400" data-id="element-962" />
                    smithsandjengs@yahoo.com
                  </a>
                </div>
              </div>
            </div>
          </motion.div>
        </div>
      </section>

      {/* Get In Touch & Map */}
      <section className="container mx-auto px-6 md:px-12 py-16" data-id="element-963">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center" data-id="element-964">
          <motion.div initial={{
          opacity: 0,
          x: -30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6
        }} data-id="element-965">
            <h2 className="text-4xl md:text-5xl font-heading font-bold text-primary mb-8" data-id="element-966">
              Get In Touch
            </h2>
            <div className="space-y-4 text-xl text-primary font-medium" data-id="element-967">
              <p data-id="element-968">
                T : <span className="font-normal" data-id="element-969">01869 601439</span>
              </p>
              <p data-id="element-970">
                M : <span className="font-normal" data-id="element-971">07432 285564</span>
              </p>
              <p data-id="element-972">
                E :{' '}
                <span className="font-normal" data-id="element-973">smithsandjengs@yahoo.com</span>
              </p>
            </div>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          x: 30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6
        }} className="h-[400px] rounded-2xl overflow-hidden shadow-lg border border-gray-100" data-id="element-974">
            <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d39366.45260171816!2d-1.189600100257007!3d51.89939524673859!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x4876e14e1df4e4a9%3A0x6a0c0b05b4e8e1f0!2sBicester%2C%20UK!5e0!3m2!1sen!2sus!4v1711831234567!5m2!1sen!2sus" width="100%" height="100%" style={{
            border: 0
          }} allowFullScreen loading="lazy" referrerPolicy="no-referrer-when-downgrade" data-id="element-975"></iframe>
          </motion.div>
        </div>
      </section>
    </main>;
}